import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider, stateHelperProvider) {
	var states = [
		{
			name: 'project',
			parent: 'entity',
			url: '/projects?name&page&sort',
			component: 'projectSearch',
			data: {
				viewAuthorities: ['ENTITIES_READ', 'METRICLIMIT_READ'],
				editAuthorities: ['ENTITIES_WRITE', 'METRICLIMIT_WRITE']
			},
			params: {
				name: {
					value: null,
					squash: true,
					dynamic: true
				},
				page: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				},
				sort: {
					value: 'name,asc',
					squash: true,
					dynamic: true
				},
				size: {
					value: null,
					type: 'int',
					squash: true,
					dynamic: true
				}
			}
		},
		{
			name: 'project.detail',
			url: '/{id}',
			component: 'projectDetail',
			resolve: {
				/* @ngInject */
				entity: (ProjectEntity, $transition$, entityInjector) =>
					entityInjector(ProjectEntity, $transition$.params().id, {}),
        /* @ngInject */
        allUsers: $http => $http.get('/api/users').then(response => response.data)
			}
		}
	];
	states.forEach(state => $stateProvider.state(state));
}

app.config(stateConfig);
